import { NgModule } from '@angular/core';
import { ShipmentGridComponent } from './shared/shipment-grid/shipment-grid.component';
import { SiteShipmentFormComponent } from './shipment-form/shipment-form.component';
import { ShipmentListComponent } from './shipment-list/shipment-list.component';
import { SharedModule } from '../shared';
import { ReactiveFormsModule } from '@angular/forms';
import { BarcodeScannerComponent } from './shared/barcode-scanner/barcode-scanner.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { CreateShipmentComponent } from './shipment-form/create-shipment/create-shipment.component';
import { FormQuestionService } from './shipment-form/service/form-question-service';
import { ShipmentFormFieldComponent } from './shipment-form/form-field/form-field.component';
import { AddressFormFieldComponent } from './shipment-form/address-form-field/address-form-field.component';
import { ShipmentFormService } from './shipment-form/service/shipment-form-service';
import { ShipmentSummaryComponent } from './shipment-summary/shipment-summary.component';
import { NgxPrintModule } from 'ngx-print';
import { SiteShippingToolStorage } from './service/site-shipping-tool-storage';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { CreateShipmentFormGuard } from './shipment-form/create-shipment/create-shipment-guard';
import { DocumentsModule } from '../documents/documents.module';
import { UserPermissionsModule } from '../user-permissions/user-permissions.module';
import { GlobalPopupModule } from '../global-popup';
import { UserModule } from '../user';
import { HeaderTitleModule } from '../header-title';
import { ToolbarMenuModule } from '../toolbar-menu';
import { NotificationBarModule } from '../notification-bar';
import { LayoutModule } from '../layout';
import { NavigationModule } from '../navigation';
import { DeleteDialogComponent } from './shared/delete-warning/delete-warning-dialog.component';
import { MyDatePickerModule } from 'mydatepicker';
import { CovanceDatePickerModule } from '../covance-date-picker/covance-date-picker.module';
import { ShipmentFormStorage } from './shipment-form/shipment-form-storage';
import { ResumeShipmentComponent } from './shipment-form/resume-shipment/resume-shipment.component';
import { ResumeShipmentFormGuard } from './shipment-form/resume-shipment/resume-shipment-guard';
import { ContainerBarcodeHandlerComponent } from './shipment-form/container-barcode-handler/container-barcode-handler.component';
import { ProtocolShipmentListComponent } from './protocol-shipment-list/protocol-shipment-list.component';
import { ProtocolShipmentService } from './service/protocol-shipment-list.service';
import { SiteShippingLoaderComponent } from './site-shipping-loader';
import { ShipmentRegisteredSamplesComponent } from './shipment-form/container-barcode-handler/registered-samples/registered-samples.component';
import { SubmittedShipmentListComponent } from './submitted-shipment-list/submitted-shipment-list.component';
@NgModule({
    declarations: [
        ShipmentGridComponent,
        ShipmentListComponent,
        BarcodeScannerComponent,
        CreateShipmentComponent,
        ShipmentFormFieldComponent,
        AddressFormFieldComponent,
        BarcodeScannerComponent,
        ShipmentSummaryComponent,
        ConfirmDialogComponent,
        DeleteDialogComponent,
        SiteShipmentFormComponent,
        ResumeShipmentComponent,
        ContainerBarcodeHandlerComponent,
        ProtocolShipmentListComponent,
        SiteShippingLoaderComponent,
        ShipmentRegisteredSamplesComponent,
        SubmittedShipmentListComponent
    ],
    imports: [
        SharedModule,
        DocumentsModule,
        NavigationModule,
        UserPermissionsModule,
        GlobalPopupModule,
        ReactiveFormsModule,
        UserModule,
        HeaderTitleModule,
        ToolbarMenuModule,
        NotificationBarModule,
        LayoutModule,
        ZXingScannerModule,
        NgxPrintModule,
        MyDatePickerModule,
        CovanceDatePickerModule,
        DragDropModule
    ],
    exports: [
        BarcodeScannerComponent,
    ],
    providers: [
        FormQuestionService,
        ShipmentFormStorage,
        SiteShippingToolStorage,
        CreateShipmentFormGuard,
        ShipmentFormService,
        ShipmentFormStorage,
        ResumeShipmentFormGuard,
        ProtocolShipmentService
    ],
    entryComponents: [
        ConfirmDialogComponent,
        DeleteDialogComponent
    ],
})
export class SiteShippingToolModule { }
